export const SNACKBAR_TIMER_INFO = 5;
export const SNACKBAR_TIMER_UNDO = 5;
export const SNACKBAR_TIMER_DELETE = 10;
